import React, { useRef, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { DropdownMenuSeparator } from '@/components/ui/dropdown-menu';

interface MerchantListProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const SearchSection = ({ searchQuery, setSearchQuery }: MerchantListProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    if (searchQuery && inputRef.current) {
      // Clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Set new timeout
      timeoutRef.current = setTimeout(() => {
        if (inputRef.current && document.activeElement !== inputRef.current) {
          inputRef.current.focus();
        }
      }, 10);
    }

    // Cleanup on unmount or searchQuery change
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [searchQuery]);

  return (
    <React.Fragment>
      <div className="flex p-3 gap-2 items-center h-11">
        <Search size={16} />
        <Input
          ref={inputRef}
          placeholder="Search stores"
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
          }}
          className="border-none !h-full !outline-none !focus:outline-none !focus-visible:outline-none !shadow-none !focus:shadow-none !focus-visible:shadow-none !ring-0 !focus:ring-0 !focus-visible:ring-0 !ring-offset-0 !focus:ring-offset-0 !focus-visible:ring-offset-0 p-0"
        />
      </div>
      <DropdownMenuSeparator />
    </React.Fragment>
  );
};
